import React, {useEffect} from 'react';
import {NavigateFunction, Route, Routes, useLocation, useNavigate} from "react-router-dom";

// Utility function for parsing search parameters
const getSearchParam = (search: string, key: string): string | null => {
    return new URLSearchParams(search).get(key);
};

const Container = () => {
    const navigate: NavigateFunction = useNavigate();
    const search: string = useLocation().search;
    const error = getSearchParam(search, "error");
    const consentId = getSearchParam(search, "cid");

    // Redirect to home if consentId is blank
    useEffect(() => {
        if (!consentId) {
            navigate('/');
        }
    }, [consentId, navigate]);

    if (!consentId) {
        return <div className="container">Redirecting...</div>;
    }

    return (
            <div className="container">
                {error == null ? (
                        <div className="alert alert-success d-flex align-items-center" role="alert">
                            <div className="col-1 d-flex justify-content-center align-items-center">
                                <i className="bi bi-check-circle-fill"></i>
                            </div>
                            <div className="col text-left">
                                <h3 className="alert-heading">Success</h3>
                                <p>Payment successful for consent ID: {consentId}</p>
                            </div>
                        </div>
                ) : (
                        <div className="alert alert-danger d-flex align-items-center" role="alert">
                            <div className="col-1 d-flex justify-content-center align-items-center">
                                <i className="bi bi-exclamation-circle-fill"></i>
                            </div>
                            <div className="col text-left">
                                <h3 className="alert-heading">Error</h3>
                                <p>Payment unsuccessful for consent ID: {consentId}</p>
                                <p>{error}</p>
                            </div>
                        </div>
                )}
                <button className="btn btn-primary mt-3" onClick={() => navigate('/')}>
                    Back to Shopping Cart
                </button>
            </div>
    );
};

export default function Redirect() {
    return (
            <Routes>
                <Route path="/" element={<Container/>}/>
            </Routes>
    );
}
